import { useQuery } from '@tanstack/react-query';
import toursApi from '@/features/dashboard/tours/api/toursApi.ts';
import { toursApiQueryKeys } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';
import { TourStatus } from '@/features/dashboard/tours/types/TourStatus.ts';

const useGetArchiveReadiness = (tourId: string, status: TourStatus) => {
  return useQuery({
    queryKey: toursApiQueryKeys.archiveReadiness(tourId),
    queryFn: () => toursApi.getArchiveReadiness(tourId),
    enabled: status === TourStatus.READY || status === TourStatus.CANCELLED,
  });
};

export default useGetArchiveReadiness;
